import React from "react";
import styles from "./index.module.scss";

interface TableHeaderColumn {
  label: string;
  innerWrapperClass?: string;
}

const tableHeaders: TableHeaderColumn[] = [
  { label: "Member" },
  { label: "Role" },
  { label: "Status" },
  { label: "Creation Date", innerWrapperClass: styles.negativeMargin },
  { label: "Last Login" },
  { label: "Security Methods" },
];

const TableHeaders = () => {
  return (
    <div className={styles.row} role="row">
      {tableHeaders.map((header, index) => (
        <div
          key={index}
          className={styles.column}
          role="columnheader"
        >
          <div
            className={`${styles.innerWrapper} ${header.innerWrapperClass || ""}`}
          >
            <div className={styles.label}>
              {header.label}
            </div>
          </div>
        </div>
      ))}
      <div className={styles.spacer} />
    </div>
  );
};

export default TableHeaders;